import { Box, Flex } from "@chakra-ui/react";
import SuperAdminSidebar from "@root/components/superAdminDashboard/sidebar/superAdminSidebar";
import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { StyledAdminLayout } from "./styles";

const SuperAdminLayout: React.FC = () => {
    useEffect(() => {
        // Set favicon for super admin
        let existingLink = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
        if (existingLink) {
            existingLink.href = "/doaz-super-admin-favicon.svg";
        } else {
            const newLink = document.createElement("link");
            newLink.rel = "icon";
            newLink.type = "image/svg+xml";
            newLink.href = "/doaz-super-admin-favicon.svg";
            document.getElementsByTagName("head")[0].appendChild(newLink);
        }

        // Set document title for super admin
        const originalTitle = document.title;
        document.title = "Doaz Super Admin Portal";

        // Cleanup function to restore original favicon and title when leaving super admin
        return () => {
            const link = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
            if (link) {
                link.href = "/kt-small-logo.png"; // Restore original favicon
            }
            document.title = originalTitle; // Restore original title
        };
    }, []);

    return (
        <StyledAdminLayout>
            <Flex flexDir={"column"} height={"100%"} flex={1}>
                <Flex width={"100%"} height={"100%"} overflow={"hidden"}>
                    <Box height={"100%"} className="left-box">
                        <SuperAdminSidebar />
                    </Box>
                    <Box
                        width={"100%"}
                        height={"100%"}
                        className="right-box"
                        flex={1}
                        position={"relative"}
                        zIndex={1}
                    >
                        <Outlet />
                    </Box>
                </Flex>
            </Flex>
        </StyledAdminLayout>
    );
};

export default SuperAdminLayout;
